export default {
	tenantId: "medgulf",
	appId: "admin_portal",
	fileSystem: {
		bucketName: "medgulf--prod",
	},
}
